import gsap from "gsap";
import VideoModule from "./videoModule";
import Header from "./header";

const TextMediaOverlay = (() => {

    const SELECTOR_MODULE = '.module-container__text-media-overlay';

    const initialize = () => {

        const module = document.querySelector(SELECTOR_MODULE);

        if (!module) return;

        initAnimations(module);

    }



    const initAnimations = (module) => {
        const image = module.querySelector('.content__media img');

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: module,
                start: () => `top bottom`,
                end: "bottom bottom",
                markers: false,
                invalidateOnRefresh: true,
                scrub: 0.1
            }
        })
            .fromTo(image,
                {
                    filter: "grayscale(100%)",
                    y: -200,
                },
                {
                    filter: "grayscale(0)",
                    y: 0,
                    ease: 'ease.in'
                })

    }

    return {
        initialize
    }

})();


export default TextMediaOverlay;